import { createReducer } from 'reduxsauce';
import actions from './actions';

const { Types } = actions;
const INITIAL_STATE = {
  isRequesting: false,
  buddyReferralDetails: {},
  error: null,
};

const request = (state = INITIAL_STATE) => {
  return {
    ...state,
    isRequesting: true,
    error: null,
  };
};

const loadBuddyReferralSuccess = (state = INITIAL_STATE, { buddyReferralDetails }) => {
  return {
    ...state,
    isRequesting: false,
    buddyReferralDetails,
  };
};

const failure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isRequesting: false,
    buddyReferralDetails: {},
    error,
  };
};

export const HANDLERS = {
  [Types.LOAD_BUDDY_REFERRAL_REQUEST]: request,
  [Types.LOAD_BUDDY_REFERRAL_SUCCESS]: loadBuddyReferralSuccess,
  [Types.LOAD_BUDDY_REFERRAL_FAILURE]: failure,
};

export default createReducer(INITIAL_STATE, HANDLERS);
